import TagLine from "./Tagline";

const Heading = ({
  className,
  title,
  text,
  tag,
  headingclassName,
  textclassName,
  tagclassName,
}) => {
  return (
    <div
      className={`mx-auto mb-12 max-w-[50rem] text-center md:text-center lg:mb-20 ${className} `}
    >
      {title && (
        <h2
          className={`h2 h7 mb-2 transform text-5xl uppercase transition-all hover:scale-105 2xl:text-6xl ${headingclassName}`}
        >
          {title}
        </h2>
      )}
      {text && (
        <p className={`body-2 mt-4 text-n-4 ${textclassName} `}>{text}</p>
      )}
      {tag && (
        <TagLine
          className={`mb-4 justify-center text-center 2xl:text-base ${tagclassName}`}
        >
          {tag}
        </TagLine>
      )}
    </div>
  );
};

export default Heading;
